import { render, staticRenderFns } from "./main.vue?vue&type=template&id=b46c454a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46c454a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b46c454a')) {
      api.createRecord('b46c454a', component.options)
    } else {
      api.reload('b46c454a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=b46c454a&scoped=true", function () {
      api.rerender('b46c454a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkFile/Select/main.vue"
export default component.exports